module.exports = __webpack_public_path__ + "img/steel-img-4.0dcf69f9.png";